import React from "react"

const Hero = ({ title = "", children }) => (
  <div className="body">
    <div className="capitalize font-heading text-hero md:text-hero-md lg:text-hero-lg xl:text-hero-xl break-all">
      {title}
    </div>
    {children}
  </div>
)

export default Hero
